
  import Vue, {PropType} from "vue";
  import {WEB_ADS_SLOTS_TYPE} from "@/services/ads";

  export default Vue.extend({
    name: 'pwa-web-ad-responsive',
    components: {
      PwaWebAdBanner: () => import('@/components/ads/PwaWebAdBanner.vue'),
    },
    props: {
      adUnitData: {
        type: Object as PropType<WEB_ADS_SLOTS_TYPE>,
        required: true,
      },
      insStyle: {
        type: String,
        default: 'display:inline-block;',
        required: false,
      },
      adFormat: {
        type: String,
        default: 'auto',
        required: false,
      },
      adFullWidthResponsive: {
        type: String,
        default: 'false',
        required: false,
      },
      extraClass: {
        type: String,
        default: '',
        required: false,
      },
      refreshTime: {
        type: Number,
        default: 30000, // milliseconds
        required: false,
      },
    },
    data() {
      return {
        loaded: true,
      };
    },
    computed: {
      adUnitId(): string {
        return this.adUnitData.adUnitId;
      },
      adWidth(): string {
        let adWidth = '100%';
        if (this.adUnitData?.adSize?.width !== undefined) {
          adWidth = `${this.adUnitData.adSize.width}px`;
        }

        return adWidth;
      },
      adHeight(): string {
        let adHeight = this.loaded ? 'auto' : '0';

        if (this.adUnitData?.adSize?.height !== undefined) {
          adHeight = `${this.adUnitData.adSize.height}px`;
        }

        return adHeight;
      },
    },
    methods: {
      onWebAdLoaded(loaded: boolean) {
        this.loaded = loaded;
        this.$emit('adLoaded', loaded);
      },
    },
  });
